import * as actionType from "../cart/actionType";
import AxiosProvider from "../../../AxiosProvider";
import AxiosProvider2 from "../../../AxiosProvider2";
import { applicationId } from "../../../config";
import AxiosProvider3 from "../../../AxiosProvider3";

let num = 0;

export const deleteItem = (cartId, id, token) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionType.DELETE_ITEM_REQUEST,
      });

      let cart = JSON.parse(localStorage.getItem("cart"));
      const indexToRemove = cart.findIndex((item) => item.id === id);

      if (indexToRemove !== -1) {
        cart.splice(indexToRemove, 1);
        localStorage.setItem("cart", JSON.stringify(cart));
      } else {
        console.log("Product not found in cart.");
      }

      // await AxiosProvider.delete(`/cart/${cartId}/meal/${id}`, {
      //   headers: {
      //     Authorization: "Bearer " + token,
      //     Accept: "application/json",
      //   },
      // });

      dispatch({
        type: actionType.DELETE_ITEM_SUCCESS,
        payload: { cartId, id },
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: actionType.DELETE_ITEM_FAILURE,
        error: e,
      });
    }
  };
};

export const clearcart = (cartId, token) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionType.CLEAR_CART_REQUEST,
      });

      localStorage.removeItem("cart");

      // await AxiosProvider.delete(`/cart/${cartId}`, {
      //   headers: {
      //     Authorization: "Bearer " + token,
      //     Accept: "application/json",
      //   },
      // });

      dispatch({
        type: actionType.CLEAR_CART_SUCCESS,
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: actionType.CLEAR_CART_FAILURE,
        error: error,
      });
    }
  };
};

export const editQuantity = (productId, quantity) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionType.EDIT_QUANTITY_REQUEST });

      let products = JSON.parse(localStorage.getItem("cart")) || [];

      const productIndex = products.findIndex(
        (item) => item.productId === productId
      );

      if (productIndex !== -1) {
        products[productIndex].quantity = quantity;

        const cart = localStorage.setItem("cart", JSON.stringify(products));

        num++;

        dispatch({ type: actionType.EDIT_QUANTITY_SUCCESS, payload: num });
      } else {
        alert("Product not found.");
        dispatch({
          type: actionType.EDIT_QUANTITY_FAILURE,
          error: "Product not found.",
        });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: actionType.EDIT_QUANTITY_FAILURE, error: error });
    }
  };
};

export const check_offer_before_create = (data, token) => {
  const cart = JSON.parse(localStorage.getItem("cart"));
  const branchId = JSON.parse(localStorage.getItem("branchId"));
  const paymentMethod = process.env.REACT_APP_PAYMENT_METHOD;
  const products = cart;
  const platform = cart[0].platform;
  const notes = localStorage.getItem("notes");
  const phoneNumber = localStorage.getItem("phoneNumber");
  const localToken = localStorage.getItem("TOKEN");

  // Parse the token from localStorage to check if user is guest
  let parsedLocalToken;
  try {
    parsedLocalToken = localToken ? JSON.parse(localToken) : null;
  } catch (e) {
    parsedLocalToken = localToken; // If parsing fails, use raw value
  }
  
  const isGuest = parsedLocalToken === "token" || parsedLocalToken === null || parsedLocalToken === undefined;

  var body = {
    token: data.token || "",

    paymentMethod: paymentMethod,
    code: data.code,
    notes: notes,
    date: "",
    now: "true",
    time: "",
    branchId: branchId,
    tableId: JSON.parse(localStorage.getItem("tableId")),
    typeId: JSON.parse(localStorage.getItem("typeId")),
    products: products,
    platform: platform,
    phone: phoneNumber,
    tablePrice: 0,
  };

  // Build headers conditionally - only include Authorization for signed-in users
  const headers = {
    Accept: "application/json",
  };
  
  // Only add Authorization header if user is signed in (not a guest)
  if (!isGuest && token && token !== "token") {
    headers.Authorization = `Bearer ${token}`;
  }

  return AxiosProvider.post(`/offers/check-offers`, body, {
    headers: headers,
    params: {
      applicationId: applicationId,
    },
  });
};

function getCurrentRiyadhTimestamp() {
  const dt = new Date();

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Riyadh',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const parts = formatter.formatToParts(dt);

  let year, month, day, hour, minute, second;
  for (const part of parts) {
    switch (part.type) {
      case 'year': year = part.value; break;
      case 'month': month = part.value; break;
      case 'day': day = part.value; break;
      case 'hour': hour = part.value; break;
      case 'minute': minute = part.value; break;
      case 'second': second = part.value; break;
    }
  }

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}


export const check_offer = (data, token) => {
  const cart = JSON.parse(localStorage.getItem("cart"));
  const branchId = JSON.parse(localStorage.getItem("branchId"));
  const paymentMethod = process.env.REACT_APP_PAYMENT_METHOD;
  
  // Handle null or empty cart
  if (!cart || !Array.isArray(cart) || cart.length === 0) {
    throw new Error("Cart is empty or not available");
  }
  
  const products = cart;
  const platform = cart[0].platform;
  const notes = localStorage.getItem("notes");
  const phoneNumber = localStorage.getItem("phoneNumber");
  const tableId = JSON.parse(localStorage.getItem("tableId"));
  const typeId = JSON.parse(localStorage.getItem("typeId"));
  const landingPageVisitTime = localStorage.getItem("landingPageVisitTime");
  const localToken = localStorage.getItem("TOKEN");

  // Build base body
  let body = {
    token: data.token || "",
    paymentMethod: paymentMethod,
    code: data.code,
    notes: notes,
    date: " ",
    now: "true",
    time: "",
    branchId: branchId,
    tableId: tableId,
    typeId: typeId,
    products: products,
    platform: platform,
    tablePrice: 0,
    qrSessionStartedAt: landingPageVisitTime,
    qrOrderSubmittedAt: getCurrentRiyadhTimestamp(),
  };

  // Parse the token from localStorage to check if user is guest
  let parsedLocalToken;
  try {
    parsedLocalToken = localToken ? JSON.parse(localToken) : null;
  } catch (e) {
    parsedLocalToken = localToken; // If parsing fails, use raw value
  }
  
  const isGuest = parsedLocalToken === "token" || parsedLocalToken === null || parsedLocalToken === undefined;
  
  console.log("Token check:", { localToken, parsedLocalToken, isGuest });
  
  if (!isGuest) {
    body.phone = phoneNumber;
  }

  // Build headers conditionally - only include Authorization for signed-in users
  const headers = {
    Accept: "application/json",
  };
  
  // Only add Authorization header if user is signed in (not a guest)
  if (!isGuest && token && token !== "token") {
    headers.Authorization = `Bearer ${token}`;
  }

  return AxiosProvider2.post(`/orders`, body, {
    headers: headers,
    params: {
      applicationId: applicationId,
    },
  });
};

export const fetchBranchData = (branchId, token) => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionType.FETCH_BRANCH_REQUEST });

      const response = await AxiosProvider.get(`branches/${branchId}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token ? { Authorization: "Bearer " + token } : {}),
        },
        params: {
          applicationId: applicationId,
        },
      });

      // API response shape may be either { data: { data: {...} } } or { data: {...} }.
      // We normalize it here to avoid "Cannot read properties of undefined".
      const branchData = response?.data?.data ?? response?.data;
      const isLikelyHtml =
        typeof branchData === "string" &&
        branchData.trim().length > 0 &&
        branchData.trim().startsWith("<");

      const isValidBranchPayload =
        branchData &&
        typeof branchData === "object" &&
        !Array.isArray(branchData) &&
        (typeof branchData?.enName === "string" ||
          typeof branchData?.arName === "string" ||
          typeof branchData?.referenceNo === "string" ||
          typeof branchData?.tableServices === "boolean");

      if (!branchData || isLikelyHtml || !isValidBranchPayload) {
        throw new Error(
          "fetchBranchData: invalid branch payload (possible HTML response)"
        );
      }

      dispatch({
        type: actionType.FETCH_BRANCH_SUCCESS,
        payload: branchData,
      });

      // Update localStorage only when values exist to avoid breaking downstream flows.
      if (branchData?.countryId != null) {
        localStorage.setItem("countryId", branchData.countryId);
      }
      localStorage.setItem("currentBranch", JSON.stringify(branchData));
    } catch (error) {
      
      console.error(error);
      dispatch({ type: actionType.FETCH_BRANCH_FAILURE, error: error });
    }
  };
};

export const Get_Token = (number) => {
  return AxiosProvider.post(`users/get-token?phone=${number}`);
};

export const payAgain_checkout = (token, paymentToken, orderId) => {
  var body = {
    token: paymentToken,
    applicationId: applicationId,
  };
  return AxiosProvider.post(`/orders/${orderId}/repay`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
};

export const payAgain_moyaser = (token, orderId) => {
  var body = {
    applicationId: applicationId,
  };
  return AxiosProvider.post(`/orders/${orderId}/payment-url`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
};


export const fireLoginOtp = (phone) => {
  return AxiosProvider2.post(`/fire-login-otp`, {
    phone
  });
};

export const loginWithOtp = (phone, otp) => {
  return AxiosProvider2.post(`/login`, {
    phone,
    OTP: otp
  });
};